import * as React from 'react';

export interface RelativeTimeProps {
  date: Date | string | number;
  live?: boolean;
  className?: string;
}

function fmt(d: Date | string | number): string {
  const diff = Date.now() - new Date(d).getTime();
  if (diff < 60_000) return 'just now';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
  if (diff < 604_800_000) return `${Math.floor(diff / 86_400_000)}d ago`;
  return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export function RelativeTime({ date, live = true, className }: RelativeTimeProps) {
  const [text, setText] = React.useState<string>(() => fmt(date));

  React.useEffect(() => {
    setText(fmt(date));
    if (!live) return;
    const t = setInterval(() => setText(fmt(date)), 30_000);
    return () => clearInterval(t);
  }, [date, live]);

  return (
    <span title={new Date(date).toLocaleString()} className={className}>
      {text}
    </span>
  );
}
